import { Avatar, Box, Button, Divider } from "@chakra-ui/react";
import { PriceLine } from "../../layouts/BookLayout";
import { BaseText } from "../Base/BaseText";
import { BookCard } from "./BookCard";

const BookPlanCard = () => {
  return (
    <BookCard maxW="448px" w="full">
      <Box display="flex" experimental_spaceX="10px">
        <Avatar
          h="48px"
          w="48px"
          bg="white"
          name="John Doe"
          src="https://upload.wikimedia.org/wikipedia/commons/7/7c/Profile_avatar_placeholder_large.png"
        />
        <Box>
          <BaseText color="#101828" font={["Inter", 600, "16px", "24px"]}>
            John Doe
          </BaseText>
          <BaseText color="#667085" font={["Inter", 400, "16px", "24px"]}>
            9 yrs old • Robotics: Beginner
          </BaseText>
        </Box>
      </Box>
      <BaseText mt="2" color="#667085" font={["Inter", 500, "18px", "28px"]}>
        Mondays 4-5PM
      </BaseText>

      <Box mt="2">
        <Button
          px="7"
          h="48px"
          bg="#27489B"
          border="none"
          fontFamily="Inter"
          fontWeight="500"
          fontSize="16px"
          lineHeight="24px"
          color="white"
          borderRadius="8px"
          _hover={{ bg: "#27489B", color: "white" }}
        >
          Edit Child
        </Button>
        <Button
          ml="2"
          px="6"
          h="48px"
          fontFamily="Inter"
          fontWeight="500"
          fontSize="16px"
          lineHeight="24px"
          borderRadius="8px"
          variant="outline"
        >
          Edit/Add Course
        </Button>
      </Box>

      <Divider borderColor="#EAECF0" my="5" w="auto" mx={-6} />

      <BaseText color="#667085" font={["Inter", 500, "18px", "28px"]}>
        Your Plan
      </BaseText>
      <BaseText mt="2" color="#101828" font={["Inter", 600, "20px", "24px"]}>
        4 Sessions{" "}
        <BaseText
          color="#667085"
          display={"inline"}
          font={["Inter", 500, "16px", "24px"]}
        >
          per month
        </BaseText>
      </BaseText>

      <Divider borderColor="#EAECF0" my="10px" />
      <PriceLine
        color="#667085"
        label="Robotics: Beginner"
        price="$250/month"
        labelFont={["Inter", 500, "18px", "28px"]}
        priceFont={["Inter", 700, "18px", "28px"]}
      />

      <Box mt="10px" bg="#EFF6FF" px="4" py="3" borderRadius="9px">
        <BaseText
          maxW="206px"
          color="#27489B"
          font={["Inter", 500, "14px", "20px"]}
        >
          First session free starting November 11, 2022
        </BaseText>
      </Box>
      <BaseText mt="10px" color="black" font={["Inter", 500, "12px", "17px"]}>
        You will be charged monthly starting on DATE (your second class), unless
        you cancel your subscription.
      </BaseText>
    </BookCard>
  );
};

export { BookPlanCard };
